import "../../../../business-types/laundry/modules/home/Home.css";
import "./Login.css";
import { useState } from "react";
import { useLoginForm } from "./hooks/useLoginForm";
import { useBusinessRedirect } from "./hooks/useBusinessRedirect";
import { useAuth } from "./hooks/useAuth";
import UsernameField from "./components/UsernameField";
import PasswordField from "./components/PasswordField";
import LoginButton from "./components/LoginButton";
import ForgotPasswordLink from "./components/ForgotPasswordLink";
import LoadingScreen from "../../../components/LoadingScreen";
import { ToastContainer } from "react-toastify";
import SubscriptionDialog from "./components/SubscriptionDialog";

const Login = () => {
  const [employees, setemployee] = useState<boolean>(false);
  const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState("");

  const {
    user_name,
    setUsername,
    password,
    setPassword,
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleUsernameKeyPress,
    passwordRef,
    visible,
    isLoginDisabled,
    setIsLoginDisabled,
  } = useLoginForm();

  const { handleLogin, Loading, subscriptionError } = useAuth(user_name, password, setIsLoginDisabled, setemployee);

  useBusinessRedirect(employees);

  const handleKeyPress = (event: { key: string }) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleCloseSubscriptionDialog = () => {
    setShowSubscriptionDialog(false);
  };

  const handleRenewSubscription = () => {
    // Navigate to subscription renewal page or open renewal modal
    // You can implement this based on your business logic
    setShowSubscriptionDialog(false);
    // window.location.href = "/subscription/renew";
  };

  return (
    <div className="signall" id="signup_allpage">
      <div className="colarcontainer-1" id="Left_small_container"></div>
      <div className="Container1">
        <div className="w-full px-4 sm:px-6">
          <div className="loginCard mx-auto p-6 sm:p-8">
            <div className="text-center">
              <h1 className="loginTitle text-2xl sm:text-3xl">Get's Started</h1>
              <p className="loginSubtitle mt-2 text-sm">Sign in to continue</p>
            </div>

            <div className="mt-6">
              <div className="inbox">
                <UsernameField value={user_name} onChange={(e) => setUsername(e.target.value)} onKeyPress={handleUsernameKeyPress} />
              </div>
              <div className="inbox">
                <PasswordField
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={handleKeyPress}
                  showPassword={showPassword}
                  handleClickShowPassword={handleClickShowPassword}
                  handleMouseDownPassword={handleMouseDownPassword}
                  passwordRef={passwordRef}
                />
              </div>

              <div className="loginActions">
                <LoginButton visible={visible} isLoginDisabled={isLoginDisabled} Loading={Loading} onClick={handleLogin} />
              </div>

              <div className="mt-3 flex justify-center">
                <ForgotPasswordLink />
              </div>
            </div>
          </div>
        </div>
        {subscriptionError && (
          <div className="mt-5 mx-auto w-full max-w-md sm:max-w-lg px-4 sm:px-0">
            <div className="p-4 bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-xl shadow-lg">
            <div className="flex items-center gap-3">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                <span className="text-red-500 text-lg" aria-hidden="true">
                  ⚠️
                </span>
              </div>

              <div className="text-red-800">
                <p className="text-sm">
                  <span className="font-semibold">Subscription expired.</span> Please contact our POS support team to renew.
                </p>
                <p className="text-xs mt-1">
                  <span className="font-semibold">Phone:</span> +91 98765 43210
                  <span className="mx-2 text-red-300">|</span>
                  <span className="font-semibold">Email:</span>{" "}
                  <a href="mailto:customersupport@imetanic.co" className="text-red-700 underline hover:text-red-900">
                    customersupport@imetanic.co
                  </a>
                </p>
              </div>
            </div>
            </div>
          </div>
        )}
      </div>

      {Loading ? <LoadingScreen /> : ""}

      <SubscriptionDialog open={showSubscriptionDialog} message={subscriptionMessage} onClose={handleCloseSubscriptionDialog} onRenew={handleRenewSubscription} />

      <div className="Colorcontainer"></div>
      <ToastContainer />
    </div>
  );
};

export default Login;
